import axios from 'axios';

// Set config defaults when creating the instance
const publicRequest = axios.create({
  baseURL: process.env.REACT_APP_BASEURL,
  headers: {
    'x-store-key': process.env.REACT_APP_STORE_KEY,
    'x-api-key': process.env.REACT_APP_API_KEY,
  },
});
const userRequest = axios.create({
  baseURL: process.env.REACT_APP_BASEURL,
  headers: {
    'x-store-key': process.env.REACT_APP_STORE_KEY,
    'x-api-key': process.env.REACT_APP_API_KEY,
  },
});

userRequest.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // response status is 401
      localStorage.clear();
      window.location.href = '/';
    }
    throw error;
  }
);

// Axios interceptor to set Authorization header before each request
userRequest.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export { publicRequest, userRequest };
